// Utils
import { createContentfulClient } from "~/shared/utils/contentful";

// Constants
import { CONTENTFUL_SPACE_NAME } from "@citizenm/foundation/shared/types/contentful/constants";

export default defineNuxtPlugin(({ $config }) => {
  return {
    provide: {
      contentfulClient: createContentfulClient(),
      contentfulMarketingClient: createContentfulClient(
        CONTENTFUL_SPACE_NAME.marketing,
        !!$config.public.ctfMarketingUsePreview,
      ),
    },
  };
});
